import { useCallback, useContext, useEffect, useMemo } from 'react';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { ChatQueryStatus } from '@trinity/chat';
import { QuerySocketEvent } from '@trinity/chat';
import { useChatQuerySocket } from '@trinity/chat-components/websocket';
import type { WS } from '@trinity/chat';

type Props = {
  children: React.ReactNode;
  queryIdentifier: string;
  queryStatus: ChatQueryStatus;
};

export const QueryFollowupsContainer = (props: Props) => {

  const enabled = useMemo(() => {
    return props.queryStatus === ChatQueryStatus.Complete;
  }, [props.queryStatus]);

  const dispatch = useContext(ChatStateDispatchContext);
  const socket = useChatQuerySocket(props.queryIdentifier, enabled);

  const handleFollowupsAvailable = useCallback((data: WS.QueryFollowupsAvailable.Data) => {
    dispatch({
      type: 'query-followups-available',
      payload: {
        queryIdentifier: data.queryIdentifier,
        items: data.items,
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (!socket) return;

    socket.on(QuerySocketEvent.QueryFollowupsAvailable, handleFollowupsAvailable);

    return () => {
      socket.off(QuerySocketEvent.QueryFollowupsAvailable, handleFollowupsAvailable);
    };
  }, [handleFollowupsAvailable, socket]);

  return (
    <>
      {props.children}
    </>
  );
};